import { useState, useEffect } from 'react';
import { API_CONFIG } from './../../config';

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.GATEPAYMENTS}`;

export const UsePayments = () => {
    const [allPayments, setAllPayments] = useState([]);
    const [paymentLoading, setPaymentLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUsers = async () => {
        try {
            setPaymentLoading(true);  
            setError(null);   
            
            const response = await fetch(CREATE_USER_ENDPOINT);
            
            if (!response.ok) {
                console.error(`API fetch failed with status: ${response.status}`);
                throw new Error('Failed to fetch payments data from API');
            }
            
            const data = await response.json();
            const paymentsArray = data.payments || data.items || data;
            
            if (Array.isArray(paymentsArray)) {
                setAllPayments(paymentsArray);
            } else {
                console.error("API response structure is invalid. Expected an array but received:", data);
                setAllPayments([]); 
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setError(error.message);
            setAllPayments([]); 
        } finally {
            setPaymentLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return {
        allPayments,
        paymentLoading,
        error,
        refetch: fetchUsers
    };
};

export default UsePayments;